import React from 'react';
import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material';

interface CheckboxProps extends MuiCheckboxProps {
}

const Checkbox: React.FC<CheckboxProps> = ({
    onKeyDown,
    onChange,
    disabled,
    ...props
}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
        if (['Tab', 'Shift'].includes(e.key)) return;

        // Prevent the Checkbox from submitting forms or triggering default actions on keydown
        e.preventDefault();

        if (e.key === 'Enter' && onChange && !disabled) {
            onChange(e as any, !props.checked);
        }

        if (!onKeyDown) return;
        onKeyDown(e);
    };

    return (
        <MuiCheckbox
            {...props}
            onChange={onChange}
            onKeyDown={handleKeyDown}
        />
    );
};

export default Checkbox;
